export default "__VITE_ASSET__0b7c903a__"